import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const alarmNotificationProfileTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Alarm Notification Profile',
  key: 'alarmNotificationProfile',
  main: {
    metadata: {
      layout: {
        rows: [
          ['alarmNtfyProfileId', 'last_mailing_time'],
          ['name', 'profile_type', 'frequency'],
          ['email'],
        ],
      },
    },
    fields: {
      alarmNtfyProfileId: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      last_mailing_time: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      name: {
        label: 'Profile Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 64
            }
          ]
        }
      },
      profile_type: {
        label: 'Profile Type',
        type: 'select',
        initial: 'ALARM_INSTANCE',
        validation: {
          required: true,
        },
        options: [
          {
            label: 'Alarm Definition',
            value: 'ALARM_DEFINITION',
          },
          {
            label: 'Alarm Instance',
            value: 'ALARM_INSTANCE',
          },
          {
            label: 'Intercept Alarm',
            value: 'INTERCEPT_ALARM',
          }
        ],
      },
      email: {
        label: 'Email Addresses',
        type: 'tagInputCustom',
        allowCreate: true,
        initial: '',
        placeholder: 'Type an email address and hit enter to create. You can input up to 10 emails',
        tags: [],
        validation: {
          validators: [
            {
              type: 'customFunction',
              customValidationFunction: 'emailsLimitSizeValidator',
              errorMessage: 'Please select up to 10 emails only'
            }
          ]
        }
      },
      frequency: {
        label: 'Frequency',
        hintMessage: 'The accepted format is XXY. XX is a numeric value (1-99) and Y represents the time unit: w=weeks, d=days, h=hours, m=minutes',
        type: 'text',
        initial: '',
        placeholder: '2w 4d 6h 45m',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: '^((\\d{1,2}w)?\\s*(\\d{1,2}d)?\\s*(\\d{1,2}h)?\\s*(\\d{1,2}m)?)$',
              errorMessage: 'Please enter expression similar to one of the following example: 2w 4d 6h 45m'
            }
          ]
        }
      },
    },
  },
};
